export default __webpack_public_path__ + "static/media/inicio2.6cdb4d96.jpg";